<template>
  <v-card class="mb-4 pa-4">
    <!-- Status Filter -->
    <v-row>
      <v-col cols="12">
        <span class="font-weight-bold mr-3">Status:</span>
        <v-radio-group
          :model-value="filters.statusMode"
          @update:model-value="updateFilter('statusMode', $event)"
          row
          density="compact"
          hide-details
          inline
        >
          <v-radio value="all" label="All"></v-radio>
          <v-radio value="active" label="Active"></v-radio>
          <v-radio value="suspended" label="Suspended"></v-radio>
          <v-radio value="not_provisioned" label="Not Provisioned"></v-radio>
          <v-radio value="terminated" label="Terminated"></v-radio>
          <v-radio value="unallocated" label="Unallocated"></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Network Filter -->
    <v-row v-if="networks.length > 0" class="mt-2">
      <v-col cols="12">
        <span class="font-weight-bold mr-3">Network:</span>
        <v-radio-group
          :model-value="filters.network_id"
          @update:model-value="updateFilter('network_id', $event)"
          row
          density="compact"
          hide-details
          inline
        >
          <v-radio :value="null" label="All"></v-radio>
          <v-radio
            v-for="network in networks"
            :key="network.id"
            :value="network.id"
            :label="network.name"
          ></v-radio>
        </v-radio-group>
      </v-col>
    </v-row>

    <!-- Search -->
    <v-row class="mt-3">
      <v-col cols="12" md="6">
        <v-text-field
          :model-value="filters.search_term"
          @update:model-value="updateFilter('search_term', $event)"
          label="Search"
          placeholder="Search by IMSI, serial, or MSISDN..."
          clearable
          dense
          outlined
          hide-details
          @keyup.enter="$emit('search')"
          @click="$event.target.select()"
          @dblclick="updateFilter('search_term', '')"
        ></v-text-field>
      </v-col>
    </v-row>

    <!-- Client Hierarchy Filter -->
    <v-row class="mt-3" align="center">
      <v-col cols="12" md="8">
        <ClientSearchFilter
          :model-value="filters.client_id"
          :include-subclients="includeSubclients"
          :clients-hierarchy="clientsHierarchy"
          client-select-label="Client"
          @update:model-value="onClientChange"
          @update:include-subclients="$emit('update:includeSubclients', $event)"
        />
      </v-col>
      <!-- IMSI Group Filter (only if client has groups) -->
      <v-col v-if="imsiGroups.length > 0" cols="12" md="4">
        <v-select
          :model-value="filters.imsi_group_id"
          @update:model-value="updateFilter('imsi_group_id', $event)"
          :items="imsiGroupsWithAll"
          item-value="id"
          item-title="name"
          label="IMSI Group"
          clearable
          density="compact"
          hide-details
        ></v-select>
      </v-col>
    </v-row>


    <!-- Action Buttons -->
    <v-row class="mt-4">
      <v-col cols="12" class="d-flex gap-2">
        <v-btn color="primary" @click="$emit('search')" :loading="loading">
          Search
        </v-btn>
        <v-btn variant="outlined" @click="$emit('reset')">
          Reset
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          variant="outlined"
          color="success"
          @click="$emit('export')"
          :disabled="!hasResults"
        >
          Export CSV
        </v-btn>
      </v-col>
    </v-row>
  </v-card>
</template>

<script>
import ClientSearchFilter from '@/components/ClientSearchFilter.vue';

export default {
  name: 'ImsiFilters',
  components: {
    ClientSearchFilter
  },
  props: {
    filters: {
      type: Object,
      required: true
    },
    networks: {
      type: Array,
      default: () => []
    },
    imsiGroups: {
      type: Array,
      default: () => []
    },
    clientsHierarchy: {
      type: [Array, null],
      default: null
    },
    hasSubclients: {
      type: Boolean,
      default: false
    },
    includeSubclients: {
      type: Boolean,
      default: true
    },
    loading: {
      type: Boolean,
      default: false
    },
    hasResults: {
      type: Boolean,
      default: false
    }
  },
  emits: [
    'update:filters',
    'update:includeSubclients',
    'search',
    'reset',
    'export',
    'clientChange'
  ],
  computed: {
    imsiGroupsWithAll() {
      return [
        { id: null, name: 'All Groups' },
        ...this.imsiGroups
      ];
    }
  },
  methods: {
    updateFilter(key, value) {
      this.$emit('update:filters', { ...this.filters, [key]: value });
    },
    onClientChange(value) {
      this.$emit('update:filters', { ...this.filters, client_id: value, imsi_group_id: null });
      this.$emit('clientChange');
    }
  }
}
</script>
